export default "__VITE_ASSET__Cgs9$Qlb__"